import { Empty } from "antd";
import React from "react";

const Models = ({
  icon,
  title,
  modelTitle,
  description,
  info,
  steps,
  type,
  contents
}) => {

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          borderBottom: "1px solid #ECECEC",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          {icon}
          <h4
            style={{
              fontSize: "clamp(0.875rem, 0.85rem + 0.125vw, 1rem)",
              margin: 0,
            }}
          >
            {title}
          </h4>
        </div>
        <div>
          <h4 style={{ fontSize: "clamp(0.875rem, 0.85rem + 0.125vw, 1rem)" }}>
            {steps} {type}
          </h4>
        </div>
      </div>
      {contents?.length > 0 ? contents?.map(content =>
        <div style={{ padding: "10px 35px " }}>
          <h3 style={{ margin: 0 }}>{content.name}</h3>
          {content.link && <a href={content.link} target="_blank" rel="noreferrer">Acessar Conteúdo</a>}
        </div>
      ) :
        <>
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={"Nenhum conteúdo disponível"}
          />
        </>
      }
    </>
  );
};

export default Models;
